import React from 'react';
import Modal from 'react-bootstrap/Modal';
import GradientButton from "../GradientButton";

import useRequest from '../../../hooks/useRequest';

import './styles.scss';

const InputText = ({ className, show, title, body, footer, handleClose, action, legend, error }) => {

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    return <Modal className={className} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="modal-text">
                {body}
            </div>
            <div className="modal-error">
                {(success === false && message) &&
                    <p className="error-messages">{message}</p>
                }
            </div>
            <div className="modal-accion">
                <GradientButton legend={legend} handleClick={() => action()}/>
            </div>
        </Modal.Body>
        <Modal.Footer>
            {footer}
        </Modal.Footer>
    </Modal>
}

export default InputText;